import { registerBrick } from 'olympe';
import { ReactBrick } from '@olympeio/core';
import React from 'react';
import {MassUpdateDialogComponent } from './renderers/MassUpdateDialogComponent.jsx'


export default class MassUpdateDialog extends ReactBrick {

    /**
      * @override
      * @protected
      * @param {!BrickContext} $
      * @param {!Array<*>} properties
      * @return {Element}
      */
    static getReactComponent($) {
        return () => {
            return (<MassUpdateDialogComponent context={$}></MassUpdateDialogComponent>)
        }
    }
}

registerBrick('019b69c5a13766d5df8b', MassUpdateDialog);
